<template>
  <div>
    <div class="bg" ref='bg' @click="bgBtn()"></div>
    <div class="service-box" ref="service">
      <ul class="service">
        <li @click="bgBtn()">
          <router-link to="/service">智联生活</router-link>
        </li>
        <li @click="bgBtn()">
          <router-link to="/explain">配网说明</router-link>
        </li>
        <li>
          <wx-open-launch-weapp
              username="gh_90066b5f8f65"
              path="pages/index/index"
              id="gh_90066b5f8f65"
              style="display: inline-block;border: none;">
            <script type="text/wxtag-template">
              <style>.btn {
                font-size: 15px;
                color-adjust: inherit;
                color: inherit;
                text-decoration: none;
              }</style>
              <span class="btn">设备配网</span>
            </script>
          </wx-open-launch-weapp>
        </li>
        <!--				<li @click="bgBtn()"><a href="http://www.winnermicro.com/airkiss/oneshot.php">设备配网</a></li>-->
      </ul>
    </div>
    <ul class="smartMenu">
      <li class="l1" :class="active == 1 ? 'active' : ''" @click="bgBtn()">
        <span></span>
        我的设备
        <p :class="isAlarm == 0 ? '' : 'isAlarm'"></p>
      </li>
      <li class="l2" :class="active == 2 ? 'active' : ''" @click="serviceBtn()">
        <span></span>
        产品应用
      </li>
      <li class="l3" :class="active == 3 ? 'active' : ''" @click="goPatth('/repair')">
        <span></span>
        故障报修
      </li>
      <li class="l4" :class="active == 4 ? 'active' : ''" @click="goPatth('/personal')">
        <span></span>
        我的
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'smartMenu',
  data() {
    return {
      dis: 1,
    }
  },
  props: ['active', 'isAlarm'],
  mounted() {
    const oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
    oScript.onload = this.wxmini
    document.body.appendChild(oScript);
  },
  methods: {
    wxmini() {
      this.Api.getWxAcc(window.location.href, function (msg) {
        const wxConfig = {
          beta: false,
          debug: false,
          appId: msg.data.appId,
          timestamp: msg.data.timestamp,
          nonceStr: msg.data.nonceStr,
          signature: msg.data.signature,
          jsApiList: [
            'chooseImage',
            'previewImage'
          ],
          openTagList: ['wx-open-launch-weapp']
        }
        wx.config(wxConfig)
        wx.ready(() => {
          console.log('ready')
        });
      });
    },
    goPatth(path) {
      this.bgBtn();
      this.$router.push({
        path: path
      })
    },
    serviceBtn() {
      if (this.dis == 1) {
        this.$refs.service.style.display = 'block';
        this.$refs.bg.style.display = 'block';
        this.dis = 2;
      } else {
        this.$refs.service.style.display = 'none';
        this.$refs.bg.style.display = 'none';
        this.dis = 1;
      }
    },
    bgBtn(c) {
      this.dis = 1;
      this.$refs.service.style.display = 'none';
      this.$refs.bg.style.display = 'none';
    },
  }
};
</script>

<style scoped>
@import url('./style/index.css');

.bg {
  width: 100%;
  height: 100vh;
  z-index: 0;
  position: fixed;
  top: 0;
  display: none;
}

.service-box {
  display: none;
  width: 31%;
  position: fixed;
  left: 22%;
  bottom: 56px;
  z-index: 1;
}

.service {
  text-align: center;
}

.service li {
  padding: 10px 0px;
  font-size: 15px;
  border: 1px solid #eee;
  border-bottom: none;
  /* margin: 4px; */
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue